import React from "react";
import { Box, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import {styled} from "@mui/material/styles";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBarsFilter, faPlus} from "@fortawesome/pro-solid-svg-icons";
import CardMenuButton from "../CardMenuButton";
import SearchTextField from "../SearchTextField";
import Xpi from "../Xpi";
import * as uuid from "uuid";

const colcol = "#68b0f2";
const HeaderBox = styled(Box)(
	({ theme, headerheight }) => `
	background: #68b0f2;
    top: 0;
    z-index: 100;
    height: ${headerheight}px;
    min-height: ${headerheight}px;
    position: sticky;
    top: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: "center";
    padding: ${theme.spacing(1)} ${theme.spacing(2)};
`
);

const HeaderContentBox = styled(Box)(
	({ theme }) => `
	display: flex;
	flex-direction: row;
	width: 100%;
	justify-content: space-between;
	height: 100%;
`
);

const HeaderSecondaryContentBox = styled(Box)(
	({ theme }) => `
	display: flex;
	flex-direction: row;
	width: 100%;
	justify-content: space-between;	
	height: 30px;
`
);

const HeaderSearchBox = styled(Box)(
	({ theme }) => `	
	width: 100%;
	background-color: #fff;
	border-radius: 6px;`
);


const ContentBox = styled(Box)(
	({ theme, headerheight }) => `
	min-height: ${headerheight}px;
	height: calc(100% - ${headerheight}px);
	overflow-x: hidden;
	overflow-y: auto;	
	box-shadow: inset 0 4px 5px -5px rgb(200 200 200 / 1)
`
);

const CardElement = ({
						 title,
						 subtitle,
						 moreActions,
						 avatar = null,
						 children,
						 menuItems,
						 secondaryMenu,
						 search,
						 subHeader,
						 pi
					 }) => {
	// const [headerHeight, setHeaderHeight] = useState(search ? 120 : 80);
	const hh = search ? 120 : 80;
	return (
		<Box sx={{height: "100%", overflowY: "auto"}}>
			<HeaderBox id={"HeaderBox"} >
				<HeaderContentBox id={"HeaderContentBox"}>
					<Box
						id={"hcb1"}
						sx={{
							visibility: "hidden",
							flex: 1,
							justifyContent: "flex-start",
							width: "auto"
						}}
					>
					</Box>
					<Box
						id={"hcb2"}
						sx={{
							flex: 2,
							alignContent: "center"
						}}
					>
						{avatar ?
							<Box sx={{marginRight: 1, display: "flex", justifyContent: "start"}}>
								{avatar}
							</Box>
							:
							<Box sx={{visibility: "hidden", display: "none"}}/>
						}
						<Box
							id={"Titlebox"}
							sx={{
								display: "flex",
								flexDirection: "column",
								justifyContent: "center",
								alignItems: "center"
							}}
						>
							<Typography color="text.primary" variant="h3" fontWeight="bolder">
								{title}
							</Typography>
							{subtitle &&
							<Typography color="text.secondary" variant="subtitle1" fontWeight="400">
								{subtitle}
							</Typography>
							}
						</Box>
					</Box>
					<Box
						id={"hcb3"}
						sx={{
							flex: 1,
							display: "flex",
							justifyContent: "flex-end",
							flexDirection: "row",
							alignItems: "center"
						}}
					>
						{moreActions &&
							<CardMenuButton filterItems={moreActions} >
								<FontAwesomeIcon icon={faBarsFilter} size={"xs"} color={"#3c82f7"}/>
							</CardMenuButton>
						}
						{menuItems &&
							<CardMenuButton menuItems={menuItems} >
								<FontAwesomeIcon icon={faPlus} size={"xs"} color={"#3c82f7"}/>
							</CardMenuButton>
						}
					</Box>
				</HeaderContentBox>
				<Box id={"HeaderSecondaryContentBox"}
					sx={{
						height: "auto"
						// bgcolor: "red"
					}}
				>
					{
						secondaryMenu &&
							<ToggleButtonGroup
								value={secondaryMenu?.value}
								exclusive
								onChange={secondaryMenu?.onChange}
								sx={{
									width: "300px",
									display: "flex",
									justifyContent: "center"
								}}
							>
								{
									secondaryMenu.items.map((item) => (
										<ToggleButton
											key={uuid.v4()}
											value={item.value}
											onClick={item.onClick}
											sx={{
												...item.sx,
												textTransform: "none",
												color: "#151c42",
												height: "28px",
												width: "100px",
												"&.Mui-selected": {
													backgroundColor: "#daebff",
													color: "#151c42",
													"&:hover": {
														backgroundColor: "#daebff",
														color: "#151c42"
													}
												},
												"&:hover": {
													backgroundColor: "#daebff",
													color: "#151c42"
												}
											}}
										>
											{item.label}
										</ToggleButton>
									))
								}
							</ToggleButtonGroup>
					}
					{
						search &&
						<SearchTextField
							searchString={search?.searchString}
							setSearchString={search?.setSearchString}
							placeholder={search?.placeholder}
							sx={{
								marginTop: 1,
								width: "300px",
								// height: "26px",
								display: "flex",
								justifyContent: "center"
								// bgcolor: "#243261"

							}}
							slotProps={{
								input: {
									sx: {
										// height: "20px",
										bgcolor: "#daebff",
										borderRadius: "6px",
										width: "50%",
										"&:focus-within": {
											width: "100%"
										},
										transition: "width 0.3s"
									}
								}
							}}
						/>
					}
					{
						subHeader &&
						<HeaderSecondaryContentBox id={"HeaderSecondaryContentBox"}>
							{subHeader}
						</HeaderSecondaryContentBox>
					}
				</Box>
			</HeaderBox>
			<ContentBox >
				{children}
				{pi && pi.length > 0 && (
					<Xpi keyname={pi}/>
				)}
			</ContentBox>
		</Box>
	);
};
export default CardElement;


// { /*{moreActions &&*/ }
// { /*	<Box sx={{display: "flex", marginRight: secondaryMenuItem ? "-41px" : 0}}>*/ }
// { /*		{moreActions?.map((option, key) => (*/ }
// { /*			<Fragment key={option.label}>*/ }
// { /*				{key !== 0 && <Typography*/ }
// { /*					sx={{mt: "4px", mx: "8px", fontWeight: "bold", color: "#c7c7c7"}}>|</Typography>}*/ }
// { /*				<Button*/ }
// { /*					key={option.label}*/ }
// { /*					sx={{*/ }
// { /*						"&.MuiButton-text": {*/ }
// { /*							color: "#404040",*/ }
// { /*							fontSize: 12,*/ }
// { /*							fontWeight: !option.active ? "bold" : 500,*/ }
// { /*							textDecoration: option.active ? "underline" : "none"*/ }
// { /*						},*/ }
// { /*						"&.MuiButton-root:hover": {*/ }
// { /*							backgroundColor: "transparent"*/ }
// { /*						}*/ }
// { /*					}}*/ }
// { /*					disabled={option.active}*/ }
// { /*					onClick={() => option.cb()}*/ }
// { /*				>*/ }
// { /*					{option.label}*/ }
// { /*				</Button>*/ }
// { /*			</Fragment>*/ }
// { /*		))}*/ }
// { /*	</Box>*/ }
// { /*}*/ }
